module.exports = __webpack_public_path__ + "static/media/img1Mobile.3701cff9.jpg";